export const SAVE_REGISTRATION = "SAVE_REGISTRATION"
export const RESET_REGISTRATION = "RESET_REGISTRATION"
